// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rai-text-message__content{border-radius:16px;margin-bottom:8px;font-size:14px}.rai-text-message__sent .rai-text-message__content{background-color:var(--v-info-lighten3);color:var(--v-info-darken4)}.rai-text-message__received .rai-text-message__content{background-color:var(--v-ui-lighten3)}", ""]);
// Exports
module.exports = exports;
